import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Chip,
  Box,
  Card,
  CardContent,
  Paper,
  AppBar,
  Hidden,
  Tabs,
  Tab,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import { AdminPreferencesService } from "../../services/adminPref.Service";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import { handleError } from "../../helper";
import { AppDataContext } from "../../common/appContext";
import CancelIcon from "@mui/icons-material/Cancel";

import statData from "../../mockData/percentileHistoricalData.json";
import mahalanobisMockData from "../../mockData/mahalanobisHistoricalData.json";

import { PropTypes } from "prop-types";
import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";
import _without from "lodash/without";

import HistoricalPercentileAnthros from "./HistoricalPercentileAnthros";
import HistoricalPercentileStrengthAndAgility from "./HistoricalPercentileStrengthAndAgility";
import HistoricalPercentileShootingDrills from "./HistoricalPercentileShootingDrills";

import { HistoricalCombineResultServices } from "../../services/historicalGroupCombine.Service";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((theme) => ({
  compareGroupCard: {
    "& .MuiCardHeader-root": {
      padding: "10px 0px 0px 16px",
    },
    "& .MuiCardContent-root ": {
      padding: "10px 10px 16px 10px",
    },
    "& .MuiButtonBase-root ": {
      height: "25px",
    },
    "& .MuiChip-deleteIcon ": {
      fontSize: "18px",
    },
    "& .MuiChip-label": {
      paddingLeft: "6px",
      paddingRight: "6px",
    },
  },
  headerBox: {
    background: "#1d428a",
  },
  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "#fff",
  },
  headerTextInfo: {
    color: "rgb(29, 66, 138)",
    fontSize: "14px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },

  customDivider: {
    "&.MuiDivider-root": {
      "&::before": {
        borderTop: "4px solid #1d428a",
      },
      "&::after": {
        borderTop: "4px solid #1d428a",
      },
    },
    "& .MuiDivider-wrapper": {
      fontSize: 16,
    },
  },
}));

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const eventList = [
  {
    leagueId: "21",
    eventName: "Gleague Elite Camp",
  },
  {
    leagueId: "11",
    eventName: "Basketball Africa League",
  },
  {
    leagueId: "09",
    eventName: "NBA Draft Combine",
  },
  {
    leagueId: "23",
    eventName: "Portsmouth",
  },
];

const intialStats = {
  anthros: {
    primaryPlayer: {
      data: [],
      avg: {},
      percentile: {},
    },
    secondaryPlayer: {
      data: [],
      avg: {},
      percentile: {},
    },
    groupPecentile: {},
  },
  strengthAndAgility: {
    primaryPlayer: {
      data: [],
      avg: {},
      percentile: {},
    },
    secondaryPlayer: {
      data: [],
      avg: {},
      percentile: {},
    },
    groupPecentile: {},
  },
  shootingDrills: {
    primaryPlayer: {
      data: [],
      avg: {},
      percentile: {},
    },
    secondaryPlayer: {
      data: [],
      avg: {},
      percentile: {},
    },
    groupPecentile: {},
  },
};

const HistoricalCombineResult = ({ showAlert }) => {
  const classes = useStyles();
  const {
    user,
    selectedEventId,
    selectedEvent: currentEventID,
    combineYear: currentCombineYear,
    isShowDEXABodyFat,
  } = useContext(AppDataContext);

  const theme = useTheme();

  //#Loader Data holders
  const [loading, setLoading] = useState(false);

  //#Event Name Data holders.
  const [combineEvents, setCombineEvents] = useState(eventList);
  const [primaryEvent, setPrimaryEvent] = useState(currentEventID);
  const [secondaryEvent, setSecondaryEvent] = useState(currentEventID);

  //#Event Year Data holders.
  const [combineYearOptions, setCombineYearOptions] = useState([]);
  const [primaryYear, setPrimaryYear] = useState(currentCombineYear);
  const [secondaryYear, setSecondaryYear] = useState(currentCombineYear);

  //#Position Data holders.
  const [primaryPositionOptions, setPrimaryPositionOptions] = useState([]);
  const [secondaryPositionOptions, setSecondaryPositionOptions] = useState([]);
  const [primaryPositions, setPrimaryPositions] = useState("");
  const [secondaryPositions, setSecondaryPositions] = useState("");

  //#College or School
  const [primaryCollegeOptions, setPrimaryCollegeOptions] = useState([]);
  const [primaryCollege, setPrimaryCollege] = useState("");
  const [secondaryCollegeOptions, setSecondaryCollegeOptions] = useState([]);
  const [secondaryCollege, setSecondaryCollege] = useState("");

  //#Players Data holders.
  const [primaryPlayerOptions, setPrimaryPlayerOptions] = useState([]);
  const [primaryPlayerList, setPrimaryPlayerList] = useState([]);
  const [primaryPlayers, setPrimaryPlayers] = useState([]);
  const [secondaryPlayerOptions, setSecondaryPlayerOptions] = useState([]);
  const [secondaryPlayerList, setSecondaryPlayerList] = useState([]);
  const [secondaryPlayers, setSecondaryPlayers] = useState([]);

  //#Error Handling data holders
  const [filterError, setFilterError] = useState({
    primaryEvent: false,
    primaryYear: false,
    secondaryEvent: false,
    secondaryYear: false,
  });

  //#Common Data holders.
  const [eventId, setEventId] = useState(selectedEventId);
  const [stats, setStats] = useState(intialStats);
  const [selectedTab, setSelectedTab] = useState(0);

  //#Station wise percentile Radar Chart Data holders.
  const [anthroRadarData, setAnthroRadarData] = useState([]);
  const [strengthAndAgilityRadarData, setStrengthAndAgilityRadarData] =
    useState([]);
  const [shootingDrilsRadarData, setShootingDrilsRadarData] = useState([]);

  //#Station wise AVG Radar Chart Data holders.
  const [anthroAVGRadarData, setAnthroAVGRadarData] = useState([]);
  const [strengthAndAgilityAVGRadarData, setStrengthAndAgilityAVGRadarData] =
    useState([]);
  const [shootingDrilsAVGRadarData, setShootingDrilsAVGRadarData] = useState(
    []
  );

  //Station wise Group percentile chart data holders
  const [anthroGroupPercentile, setAnthroGroupPercentile] = useState([]);
  const [
    strengthAndAgilityGroupPercentile,
    setStrengthAndAgilityGroupPercentile,
  ] = useState([]);
  const [shootingDrilsGroupPercentile, setShootingDrilsGroupPercentile] =
    useState([]);

  //HISTORICAL COMBINE RESULT GROUP PERCENTILE DISPLAY FLAG
  const [isShowGroupPercentile, setIsShowGroupPercentile] = useState("false");

  useEffect(() => {
    async function fetchPreData() {
      await Promise.all([GetCombineYearData(), GetAllPositions()]);

      const response =
        await HistoricalCombineResultServices.getGroupPercentileDisplayFlag();
      const childName = response?.data?.[0]?.childName;

      setIsShowGroupPercentile(childName);
    }

    fetchPreData();
  }, []);

  // useEffect(() => {
  //   setPrimaryEvent(currentEventID);
  //   setPrimaryYear(currentCombineYear);
  //   setSecondaryYear([currentCombineYear]);
  // }, [selectedEventId]);

  useEffect(() => {
    //SET PERCENTILE DATA TO SHOW GRAPH
    setAnthroRadarData(formatedAnthrosRadarData(stats.anthros));
    setStrengthAndAgilityRadarData(
      formatedSASRadarData(stats.strengthAndAgility)
    );
    setShootingDrilsRadarData(formattedShootingRadarData(stats.shootingDrills));

    //SET AVERAGE DATA TO SHOW GRAPH
    setAnthroAVGRadarData(formatedAnthrosAVGRadarData(stats.anthros));
    setStrengthAndAgilityAVGRadarData(
      formatedSASAVGRadarData(stats.strengthAndAgility)
    );
    setShootingDrilsAVGRadarData(
      formattedShootingAVGRadarData(stats.shootingDrills)
    );

    //SET GROUP PERCENTILE DATA TO SHOW GRAPH
    setAnthroGroupPercentile(formatedAnthrosGroupPercentile(stats.anthros));
    setStrengthAndAgilityGroupPercentile(
      formatedSASGroupPercentile(stats.strengthAndAgility)
    );
    setShootingDrilsGroupPercentile(
      formattedShootingGroupPercentile(stats.shootingDrills)
    );
  }, [stats]);

  useEffect(() => {
    //Reset state value
    resetStateValues(setPrimaryPlayers, setPrimaryCollege);

    applyFilter(
      primaryPositions,
      setPrimaryPlayerOptions,
      setPrimaryCollegeOptions,
      primaryPlayerList
    );
  }, [primaryPositions, primaryPlayerList]);

  useEffect(() => {
    //Reset state value
    resetStateValues(setSecondaryPlayers, setSecondaryCollege);

    applyFilter(
      secondaryPositions,
      setSecondaryPlayerOptions,
      setSecondaryCollegeOptions,
      secondaryPlayerList
    );
  }, [secondaryPositions, secondaryPlayerList]);

  useEffect(() => {
    if (primaryCollege === "") {
      //Reset state value
      resetStateValues(setPrimaryPlayers, setPrimaryCollege);

      applyFilter(
        primaryPositions,
        setPrimaryPlayerOptions,
        setPrimaryCollegeOptions,
        primaryPlayerList
      );
      return;
    }

    const filteredPlayers = primaryPlayerList.filter(
      (player) => player.collegeOrClub === primaryCollege
    );

    if (primaryPositions !== "") {
      setPrimaryPlayerOptions(
        filteredPlayers.filter(
          (player) => player.positionName === primaryPositions
        )
      );
    } else {
      setPrimaryPlayerOptions(filteredPlayers);
    }
  }, [primaryCollege, primaryPlayerList, primaryPositions]);

  useEffect(() => {
    if (secondaryCollege === "") {
      //Reset state value
      resetStateValues(setSecondaryPlayers, setSecondaryCollege);

      applyFilter(
        secondaryPositions,
        setSecondaryPlayerOptions,
        setSecondaryCollegeOptions,
        secondaryPlayerList
      );
      return;
    }

    const filteredPlayers = secondaryPlayerList.filter(
      (player) => player.collegeOrClub === secondaryCollege
    );

    if (secondaryPositions !== "") {
      setSecondaryPlayerOptions(
        filteredPlayers.filter(
          (player) => player.positionName === secondaryPositions
        )
      );
    } else {
      setSecondaryPlayerOptions(filteredPlayers);
    }
  }, [secondaryCollege, secondaryPlayerList, secondaryPositions]);

  //FETCH PRIMARY PLAYERS AFTER EVENT CHANGE
  useEffect(() => {
    if (primaryEvent && primaryYear) {
      //Reset state value
      resetStateValues(setPrimaryPlayers, setPrimaryCollege);

      //Get Players.
      fetchPlayers(
        primaryEvent,
        primaryYear,
        setPrimaryPlayerOptions,
        setPrimaryPlayerList,
        setPrimaryCollegeOptions
      );
    }
  }, [primaryEvent, primaryYear, user]);

  //FETCH SECONDARY PLAYERS AFTER EVENT CHANGE
  useEffect(() => {
    if (secondaryEvent && secondaryYear) {
      //Reset state value
      resetStateValues(setSecondaryPlayers, setSecondaryCollege);

      //Get Player.
      fetchPlayers(
        secondaryEvent,
        secondaryYear,
        setSecondaryPlayerOptions,
        setSecondaryPlayerList,
        setSecondaryCollegeOptions
      );
    }
  }, [secondaryEvent, secondaryYear, user]);

  useEffect(() => {
    setDefaultValues();
    const filterObj = createFilterObject();
    fetchData(filterObj);
  }, [
    primaryEvent,
    primaryYear,
    secondaryEvent,
    secondaryYear,
    primaryCollege,
    secondaryCollege,
    primaryPositions,
    secondaryPositions,
    primaryPlayers,
    secondaryPlayers,
  ]);

  //GET PLAYERS AND SET TO DATA HOLDERS FOR MANUPULATIONS.
  const fetchPlayers = (
    event,
    year,
    setPlayerOptions,
    setPlayerList,
    setCollegeOptions
  ) => {
    const combineEventID = parseInt(`${year}${event}`);
    if (combineEventID && user?.loginID) {
      GetAllPrimaryPlayers(combineEventID)
        .then((result) => {
          const collegeList = [
            ...new Set(result?.data?.map((player) => player.collegeOrClub)),
          ];
          setPlayerOptions(result.data);
          setPlayerList(result.data);
          setCollegeOptions(collegeList);
        })
        .catch((error) =>
          console.error(`Error retrieving ${event} players:`, error)
        );
    }
  };

  function setDefaultValues() {
    setFilterError({
      primaryEvent: false,
      primaryYear: false,
      secondaryEvent: false,
      secondaryYear: false,
    });
    setStats(intialStats);
  }

  function createFilterObject() {
    const primaryEventValue = `${primaryYear}${primaryEvent}`;
    const secondaryEventValue = `${secondaryYear}${secondaryEvent}`;

    return {
      primaryEvent: primaryEventValue,
      secondaryEvent: secondaryEventValue,
      primaryPositions: primaryPositions,
      secondaryPositions: secondaryPositions,
      primaryPlayers: primaryPlayers.toString(),
      secondaryPlayers: secondaryPlayers.toString(),
      primaryCollege: primaryCollege,
      secondaryCollege: secondaryCollege,
      drillType: 0,
      userBy: user?.loginID,
    };
  }

  function fetchData(filterObj) {
    if (validateInputValues()) {
      setLoading(true);
      GetHistoricalComparisionData(filterObj);
    }
  }

  function validateInputValues() {
    let hasError = false;
    if (primaryEvent === "") {
      setFilterError((prev) => ({ ...prev, primaryEvent: true }));
      hasError = true;
    }

    if (primaryYear == null || primaryYear === 0) {
      setFilterError((prev) => ({ ...prev, primaryYear: true }));
      hasError = true;
    }

    if (secondaryEvent === "") {
      setFilterError((prev) => ({ ...prev, secondaryEvent: true }));
      hasError = true;
    }

    if (secondaryYear == null || secondaryYear === 0) {
      setFilterError((prev) => ({ ...prev, secondaryYear: true }));
      hasError = true;
    }

    // if (primaryPlayers === null || primaryPlayers === "") {
    //   setFilterError((prev) => ({ ...prev, primaryPlayers: true }));
    //   hasError = true;
    // }

    if (hasError) {
      return false;
    }

    return true;
  }

  //#API for get all Active Combine Years Data
  const GetCombineYearData = async () => {
    try {
      const response = await AdminPreferencesService.getCombineYears({});
      const combineYearData = response.data.map((item) => item.eventYear);
      setCombineYearOptions(combineYearData);
    } catch (error) {
      handleError(error);
    }
  };

  //#API for get all player positions.
  const GetAllPositions = async () => {
    try {
      const response = await PlayerProfileService.getPlayerPositions();
      const playingPositions = response.data.map((item) => item.childName);
      const sortedPositions = playingPositions.sort((a, b) =>
        a.localeCompare(b)
      );
      setPrimaryPositionOptions(sortedPositions);
      setSecondaryPositionOptions(sortedPositions);
      return response;
    } catch (error) {
      handleError(error);
    }
  };

  //GET ALL PLAYERS BY EVENT ID.
  const GetAllPrimaryPlayers = async (iEventID) => {
    return await PlayerProfileService.getPlayerListByEventIdYear(
      iEventID,
      user?.loginID
    );
  };

  //#API for get Historical Comparison Data
  const GetHistoricalComparisionData = async (obj) => {
    setStats(intialStats);
    try {
      const result =
        await HistoricalCombineResultServices.getPlayersStatsComparison(obj);

      setStats(result.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  //Event Handlers
  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  const handlePrimaryPosition = (e) => {
    const position = e.target.value;
    setPrimaryPositions(position);
    setPrimaryPlayers([]);
  };

  const handlePrimaryCollegeChange = (e) => {
    const college = e.target.value;
    setPrimaryCollege(college);
    setPrimaryPlayers([]);
  };

  //#Secondary Player Events
  const handleSecondaryPlayerChange = (event) => {
    const {
      target: { value },
    } = event;
    setSecondaryPlayers(typeof value === "string" ? value.split(",") : value);
  };

  const handleDeleteSecondaryPlayer = (e, value) => {
    e.preventDefault();
    setSecondaryPlayers((current) => _without(current, value));
  };

  //#Primary Player Events
  const handlePrimaryPlayerChange = (event) => {
    const value = event.target.value;
    setPrimaryPlayers(Array.isArray(value) ? value : value.split(","));
  };

  const handleDeletePrimaryPlayer = (e, value) => {
    e.preventDefault();
    setPrimaryPlayers((current) => _without(current, value));
  };

  //Common Handlers
  // Validate given value is number or not
  const validateNumber = (num) =>
    Number.isInteger(Number(num)) ? Number(num) : Number(num).toFixed(2);

  //Returns Anthros percentile radar data
  const formatedAnthrosRadarData = (data) => {
    const { primaryPlayer, secondaryPlayer } = data;
    const { percentile: primaryCompareGroupPercentile } = primaryPlayer;
    const { percentile: secondaryCompareGroupPercentile } = secondaryPlayer;

    return [
      {
        category: "Standing Reach",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.standingReachInches || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.standingReachInches || 0
        ),
      },
      {
        category: "Wingspan Dimension",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.wingSpanInches || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.wingSpanInches || 0
        ),
      },
      // {
      //   category: "Height with Shoes",
      //   primaryPlayerPercentile: validateNumber(
      //     primaryCompareGroupPercentile?.heightWithShoesInches || 0
      //   ),
      //   secondaryPlayerPercentile: validateNumber(
      //     secondaryCompareGroupPercentile?.heightWithShoesInches || 0
      //   ),
      // },
      {
        category: "Height Without Shoes",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.heightWithOutShoesInches || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.heightWithOutShoesInches || 0
        ),
      },
      {
        category: "Weight",
        primaryPlayerPercentile: primaryCompareGroupPercentile?.bodyWeight || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.bodyWeight || 0,
      },
      {
        category: "Hand Dimension Width",
        primaryPlayerPercentile: primaryCompareGroupPercentile?.handWidth || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.handWidth || 0,
      },
      {
        category: "Hand Dimension Length",
        primaryPlayerPercentile: primaryCompareGroupPercentile?.handLength || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.handLength || 0,
      },
      // {
      //   category: "Body Fat",
      //   primaryPlayerPercentile: primaryCompareGroupPercentile?.bodyFat || 0,
      //   secondaryPlayerPercentile:
      //     secondaryCompareGroupPercentile?.bodyFat || 0,
      // },
      ...(isShowDEXABodyFat === "true"
        ? [
            {
              category: "DEXA Body Fat",
              primaryPlayerPercentile:
                primaryCompareGroupPercentile?.bodyFatDXA || 0,
              secondaryPlayerPercentile:
                secondaryCompareGroupPercentile?.bodyFatDXA || 0,
            },
          ]
        : []),
    ];
  };

  //Returns Strength And Agility radar data
  const formatedSASRadarData = (data) => {
    const { primaryPlayer, secondaryPlayer } = data;
    const { percentile: primaryCompareGroupPercentile } = primaryPlayer;
    const { percentile: secondaryCompareGroupPercentile } = secondaryPlayer;

    return [
      {
        category: "Lane Shuttle Left",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.shuttleRunLeftTrialTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.shuttleRunLeftTrialTime || 0
        ),
      },
      {
        category: "Lane Shuttle Right",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.shuttleRunRightTrialTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.shuttleRunRightTrialTime || 0
        ),
      },
      {
        category: "3/4 Court Sprint",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.threeFourRunTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.threeFourRunTime || 0
        ),
      },
      {
        category: "Pro Lane",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.proLaneTrialTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.proLaneTrialTime || 0
        ),
      },
      {
        category: "Max Vertical Jump",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.maxVerticalLeap || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.maxVerticalLeap || 0
        ),
      },
      {
        category: "Standing Vertical",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.standingVerticalLeap || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          secondaryCompareGroupPercentile?.standingVerticalLeap || 0
        ),
      },
    ];
  };

  //Returns Shooting Drills radar data
  const formattedShootingRadarData = (data) => {
    const { primaryPlayer, secondaryPlayer } = data;
    const { percentile: primaryCompareGroupPercentile } = primaryPlayer;
    const { percentile: secondaryCompareGroupPercentile } = secondaryPlayer;
    return [
      {
        category: "Spot Up Shooting",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageSpotup || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.percentageSpotup || 0,
      },
      {
        category: "Side Mid Side Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageSideMidSide || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.percentageSideMidSide || 0,
      },
      {
        category: "Mid Side Mid Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageMidSideMid || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.percentageMidSideMid || 0,
      },
      {
        category: "Off The Dribble Shooting",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageOffTheDribble || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.percentageOffTheDribble || 0,
      },
      {
        category: "Free Throws",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentagFreeThrows || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.percentagFreeThrows || 0,
      },
      {
        category: "3 Point Star Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentage3PointStar || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.percentage3PointStar || 0,
      },
      {
        category: "Mid Range Star Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageMidRangeStar || 0,
        secondaryPlayerPercentile:
          secondaryCompareGroupPercentile?.percentageMidRangeStar || 0,
      },
    ];
  };

  //Returns Anthros AVG radar data
  const formatedAnthrosAVGRadarData = (data) => {
    const { primaryPlayer, secondaryPlayer } = data;
    const { avg: primaryCompareGroupAvg } = primaryPlayer;
    const { avg: secondaryCompareGroupAvg } = secondaryPlayer;

    return [
      {
        category: "Standing Reach",
        primaryPlayerAVG: validateNumber(
          (primaryCompareGroupAvg?.standingReachFeet || 0) * 12 +
            (primaryCompareGroupAvg?.standingReachInches || 0)
        ),
        groupAVG: validateNumber(
          (secondaryCompareGroupAvg?.standingReachFeet || 0) * 12 +
            (secondaryCompareGroupAvg?.standingReachInches || 0)
        ),
      },
      {
        category: "Wingspan Dimension",
        primaryPlayerAVG: validateNumber(
          (primaryCompareGroupAvg?.wingSpanFeet || 0) * 12 +
            (primaryCompareGroupAvg?.wingSpanInches || 0)
        ),
        groupAVG: validateNumber(
          (secondaryCompareGroupAvg?.wingSpanFeet || 0) * 12 +
            (secondaryCompareGroupAvg?.wingSpanInches || 0)
        ),
      },
      // {
      //   category: "Height with Shoes",
      //   primaryPlayerAVG: validateNumber(
      //     (primaryCompareGroupAvg?.heightWithShoesFeet || 0) * 12 +
      //       (primaryCompareGroupAvg?.heightWithShoesInches || 0)
      //   ),
      //   groupAVG: validateNumber(
      //     (secondaryCompareGroupAvg?.heightWithShoesFeet || 0) * 12 +
      //       (secondaryCompareGroupAvg?.heightWithShoesInches || 0)
      //   ),
      // },
      {
        category: "Height Without Shoes",
        primaryPlayerAVG: validateNumber(
          (primaryCompareGroupAvg?.heightWithOutShoesFeet || 0) * 12 +
            (primaryCompareGroupAvg?.heightWithOutShoesInches || 0)
        ),
        groupAVG: validateNumber(
          (secondaryCompareGroupAvg?.heightWithOutShoesFeet || 0) * 12 +
            (secondaryCompareGroupAvg?.heightWithOutShoesInches || 0)
        ),
      },
      {
        category: "Weight",
        primaryPlayerAVG:
          validateNumber(primaryCompareGroupAvg?.bodyWeight) || 0,
        groupAVG: validateNumber(secondaryCompareGroupAvg?.bodyWeight) || 0,
      },
      {
        category: "Hand Dimension Width",
        primaryPlayerAVG:
          validateNumber(primaryCompareGroupAvg?.handWidth) || 0,
        groupAVG: validateNumber(secondaryCompareGroupAvg?.handWidth) || 0,
      },
      {
        category: "Hand Dimension Length",
        primaryPlayerAVG:
          validateNumber(primaryCompareGroupAvg?.handLength) || 0,
        groupAVG: validateNumber(secondaryCompareGroupAvg?.handLength) || 0,
      },
      {
        category: "Body Fat",
        primaryPlayerAVG: validateNumber(primaryCompareGroupAvg?.bodyFat) || 0,
        groupAVG: validateNumber(secondaryCompareGroupAvg?.bodyFat) || 0,
      },
      ...(isShowDEXABodyFat === "true"
        ? [
            {
              category: "DEXA Body Fat",
              primaryPlayerAVG: primaryCompareGroupAvg?.bodyFatDXA || 0,
              groupAVG: secondaryCompareGroupAvg?.bodyFatDXA || 0,
            },
          ]
        : []),
    ];
  };

  //Returns Strength And Agility AVG radar data
  const formatedSASAVGRadarData = (data) => {
    const { primaryPlayer, secondaryPlayer } = data;

    const getPlayerAVG = (player, drill) => {
      return validateNumber(player?.avg?.[drill] || 0);
    };

    return [
      {
        category: "Lane Shuttle Left",
        primaryPlayerAVG: getPlayerAVG(
          primaryPlayer,
          "shuttleRunLeftTrialTime"
        ),
        groupAVG: getPlayerAVG(secondaryPlayer, "shuttleRunLeftTrialTime"),
      },
      {
        category: "Lane Shuttle Right",
        primaryPlayerAVG: getPlayerAVG(
          primaryPlayer,
          "shuttleRunRightTrialTime"
        ),
        groupAVG: getPlayerAVG(secondaryPlayer, "shuttleRunRightTrialTime"),
      },
      {
        category: "3/4 Court Sprint",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "threeFourRunTime"),
        groupAVG: getPlayerAVG(secondaryPlayer, "threeFourRunTime"),
      },
      {
        category: "Pro Lane",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "proLaneTrialTime"),
        groupAVG: getPlayerAVG(secondaryPlayer, "proLaneTrialTime"),
      },
      {
        category: "Max Vertical Jump",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "maxVerticalLeap"),
        groupAVG: getPlayerAVG(secondaryPlayer, "maxVerticalLeap"),
      },
      {
        category: "Standing Vertical",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "standingVerticalLeap"),
        groupAVG: getPlayerAVG(secondaryPlayer, "standingVerticalLeap"),
      },
    ];
  };

  //Returns Shooting Drills AVG radar data
  const formattedShootingAVGRadarData = (data) => {
    const { primaryPlayer, secondaryPlayer } = data;

    const getPlayerAVG = (player, drill) =>
      player?.avg ? player.avg[drill] || 0 : 0;

    return [
      {
        category: "Spot Up Shooting",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "noOfMadeSpotup"),
        groupAVG: getPlayerAVG(secondaryPlayer, "noOfMadeSpotup"),
      },
      {
        category: "Side Mid Side Drill",
        primaryPlayerAVG: primaryPlayers
          ? getPlayerAVG(primaryPlayer, "noOfMadeSideMidSide")
          : 0,
        groupAVG: getPlayerAVG(secondaryPlayer, "noOfMadeSideMidSide"),
      },
      {
        category: "Mid Side Mid Drill",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "noOfMadeMidSideMid"),
        groupAVG: getPlayerAVG(secondaryPlayer, "noOfMadeMidSideMid"),
      },
      {
        category: "Off The Dribble Shooting",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "noOfMadeOffTheDribble"),
        groupAVG: getPlayerAVG(secondaryPlayer, "noOfMadeOffTheDribble"),
      },
      {
        category: "Free Throws",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "noOfMadeFreeThrows"),
        groupAVG: getPlayerAVG(secondaryPlayer, "noOfMadeFreeThrows"),
      },
      {
        category: "3 Point Star Drill",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "noOfMade3PointStar"),
        groupAVG: getPlayerAVG(secondaryPlayer, "noOfMade3PointStar"),
      },
      {
        category: "Mid Range Star Drill",
        primaryPlayerAVG: getPlayerAVG(primaryPlayer, "noOfMadeMidRangeStar"),
        groupAVG: getPlayerAVG(secondaryPlayer, "noOfMadeMidRangeStar"),
      },
    ];
  };

  const applyFilter = (
    positions,
    setPlayerOptions,
    setCollegeOptions,
    playerList
  ) => {
    const filteredList = positions
      ? playerList.filter((player) => player.positionName === positions)
      : playerList;
    const collegeList = [
      ...new Set(filteredList?.map((player) => player.collegeOrClub)),
    ];
    setPlayerOptions(filteredList);
    setCollegeOptions(collegeList);
  };

  const resetStateValues = (setPlayers, setCollege) => {
    setPlayers([]);
    setCollege("");
  };

  //Returns Anthros percentile radar data
  const formatedAnthrosGroupPercentile = (data) => {
    const { primaryPlayer, groupPercentile } = data;
    const { percentile: primaryCompareGroupPercentile } = primaryPlayer;

    return [
      {
        category: "Standing Reach",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.standingReachInches || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.standingReachInches || 0
        ),
      },
      {
        category: "Wingspan Dimension",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.wingSpanInches || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.wingSpanInches || 0
        ),
      },
      // {
      //   category: "Height with Shoes",
      //   primaryPlayerPercentile: validateNumber(
      //     primaryCompareGroupPercentile?.heightWithShoesInches || 0
      //   ),
      //   secondaryPlayerPercentile: validateNumber(
      //     groupPercentile?.heightWithShoesInches || 0
      //   ),
      // },
      {
        category: "Height Without Shoes",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.heightWithOutShoesInches || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.heightWithOutShoesInches || 0
        ),
      },
      {
        category: "Weight",
        primaryPlayerPercentile: primaryCompareGroupPercentile?.bodyWeight || 0,
        secondaryPlayerPercentile: groupPercentile?.bodyWeight || 0,
      },
      {
        category: "Hand Dimension Width",
        primaryPlayerPercentile: primaryCompareGroupPercentile?.handWidth || 0,
        secondaryPlayerPercentile: groupPercentile?.handWidth || 0,
      },
      {
        category: "Hand Dimension Length",
        primaryPlayerPercentile: primaryCompareGroupPercentile?.handLength || 0,
        secondaryPlayerPercentile: groupPercentile?.handLength || 0,
      },
      {
        category: "Body Fat",
        primaryPlayerPercentile: primaryCompareGroupPercentile?.bodyFat || 0,
        secondaryPlayerPercentile: groupPercentile?.bodyFat || 0,
      },
      ...(isShowDEXABodyFat === "true"
        ? [
            {
              category: "DEXA Body Fat",
              primaryPlayerPercentile:
                primaryCompareGroupPercentile?.bodyFatDXA || 0,
              secondaryPlayerPercentile: groupPercentile?.bodyFatDXA || 0,
            },
          ]
        : []),
    ];
  };

  //Returns Strength And Agility radar data
  const formatedSASGroupPercentile = (data) => {
    const { primaryPlayer, groupPercentile } = data;
    const { percentile: primaryCompareGroupPercentile } = primaryPlayer;

    return [
      {
        category: "Lane Shuttle Left",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.shuttleRunLeftTrialTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.shuttleRunLeftTrialTime || 0
        ),
      },
      {
        category: "Lane Shuttle Right",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.shuttleRunRightTrialTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.shuttleRunRightTrialTime || 0
        ),
      },
      {
        category: "3/4 Court Sprint",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.threeFourRunTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.threeFourRunTime || 0
        ),
      },
      {
        category: "Pro Lane",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.proLaneTrialTime || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.proLaneTrialTime || 0
        ),
      },
      {
        category: "Max Vertical Jump",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.maxVerticalLeap || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.maxVerticalLeap || 0
        ),
      },
      {
        category: "Standing Vertical",
        primaryPlayerPercentile: validateNumber(
          primaryCompareGroupPercentile?.standingVerticalLeap || 0
        ),
        secondaryPlayerPercentile: validateNumber(
          groupPercentile?.standingVerticalLeap || 0
        ),
      },
    ];
  };

  //Returns Shooting Drills radar data
  const formattedShootingGroupPercentile = (data) => {
    const { primaryPlayer, groupPercentile } = data;
    const { percentile: primaryCompareGroupPercentile } = primaryPlayer;
    return [
      {
        category: "Spot Up Shooting",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageSpotup || 0,
        secondaryPlayerPercentile: groupPercentile?.percentageSpotup || 0,
      },
      {
        category: "Side Mid Side Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageSideMidSide || 0,
        secondaryPlayerPercentile: groupPercentile?.percentageSideMidSide || 0,
      },
      {
        category: "Mid Side Mid Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageMidSideMid || 0,
        secondaryPlayerPercentile: groupPercentile?.percentageMidSideMid || 0,
      },
      {
        category: "Off The Dribble Shooting",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageOffTheDribble || 0,
        secondaryPlayerPercentile:
          groupPercentile?.percentageOffTheDribble || 0,
      },
      {
        category: "Free Throws",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentagFreeThrows || 0,
        secondaryPlayerPercentile: groupPercentile?.percentagFreeThrows || 0,
      },
      {
        category: "3 Point Star Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentage3PointStar || 0,
        secondaryPlayerPercentile: groupPercentile?.percentage3PointStar || 0,
      },
      {
        category: "Mid Range Star Drill",
        primaryPlayerPercentile:
          primaryCompareGroupPercentile?.percentageMidRangeStar || 0,
        secondaryPlayerPercentile: groupPercentile?.percentageMidRangeStar || 0,
      },
    ];
  };

  return (
    <>
      <Container maxWidth={false}>
        {/* Common Card */}
        <Paper elevation={4} sx={{ my: 3 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            className={classes.headerBox}
          >
            <Box pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Players Comparable
              </Typography>
            </Box>
          </Box>
          <Box sx={{ p: 2 }}>
            <Card className={classes.compareGroupCard}>
              <CardContent>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={3}>
                    <FormControl
                      size="small"
                      fullWidth
                      error={filterError.primaryEvent}
                    >
                      <InputLabel>Event Name</InputLabel>
                      <Select
                        value={primaryEvent}
                        label="Event Name"
                        onChange={(e) => {
                          setPrimaryEvent(e.target.value);
                        }}
                        id="idPrimaryEvent"
                        sx={{
                          "& #idPrimaryEvent": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        {combineEvents?.map((elem, i) => {
                          return (
                            <MenuItem
                              key={i}
                              value={elem.leagueId}
                              sx={{ fontSize: "1rem" }}
                            >
                              {elem.eventName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <FormControl
                      size="small"
                      fullWidth
                      error={filterError.primaryYear}
                    >
                      <InputLabel>Year</InputLabel>
                      <Select
                        size="small"
                        label="Year"
                        value={primaryYear}
                        onChange={(e) => {
                          setPrimaryYear(e.target.value);
                        }}
                        id="idPrimaryYear"
                        sx={{
                          "& #idPrimaryYear": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        {combineYearOptions?.map((elem, i) => {
                          return (
                            <MenuItem key={i} value={elem}>
                              <span title={elem}>{elem}</span>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>Position</InputLabel>
                      <Select
                        value={primaryPositions}
                        label="Position"
                        onChange={(e) => handlePrimaryPosition(e)}
                        id="idPrimaryPosition"
                        sx={{
                          "& #idPrimaryPosition": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        <MenuItem value="">
                          <span title="None">None</span>
                        </MenuItem>

                        {primaryPositionOptions?.map((name, i) => {
                          return (
                            <MenuItem key={i} value={name}>
                              {name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>College or School</InputLabel>
                      <Select
                        size="small"
                        label="College or School"
                        value={primaryCollege}
                        onChange={(e) => handlePrimaryCollegeChange(e)}
                        id="idPrimaryCollege"
                        sx={{
                          "& #idPrimaryCollege": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        <MenuItem value="">
                          <span title="None">None</span>
                        </MenuItem>
                        {primaryCollegeOptions?.map((elem, i) => {
                          return (
                            <MenuItem key={i} value={elem}>
                              <span title={elem}>{elem}</span>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl size="small" fullWidth>
                      <InputLabel id="demo-multiple-chip-label-splayer">
                        Players
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label-splayer"
                        multiple
                        value={primaryPlayers}
                        onChange={handlePrimaryPlayerChange}
                        input={
                          <OutlinedInput
                            id="select-multiple-chip-splayer"
                            label="Chip"
                          />
                        }
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected?.map((value, index) => {
                              var sSecondaryPlayer = primaryPlayerOptions?.map(
                                (val, k) => {
                                  if (val.playerID === value) {
                                    return val.playerName;
                                  }
                                }
                              );
                              return (
                                <Chip
                                  key={index}
                                  label={sSecondaryPlayer}
                                  clickable
                                  onDelete={(e) => {
                                    handleDeletePrimaryPlayer(e, value);
                                  }}
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) =>
                                        event.stopPropagation()
                                      }
                                    />
                                  }
                                />
                              );
                            })}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                        id="idSecondaryPlayers"
                        sx={{
                          "& #idSecondaryPlayers": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        {primaryPlayerOptions?.map((name, index) => (
                          <MenuItem key={name.playerID} value={name.playerID}>
                            {name.playerName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Divider className={classes.customDivider} sx={{ my: 2 }}>
              VS
            </Divider>

            <Card className={classes.compareGroupCard}>
              <CardContent>
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={3}>
                    <FormControl
                      size="small"
                      fullWidth
                      error={filterError.secondaryEvent}
                    >
                      <InputLabel>Event Name</InputLabel>
                      <Select
                        value={secondaryEvent}
                        label="Event Name"
                        onChange={(e) => {
                          setSecondaryEvent(e.target.value);
                        }}
                        id="idSecondaryEvent"
                        sx={{
                          "& #idSecondaryEvent": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        {combineEvents?.map((elem, i) => {
                          return (
                            <MenuItem
                              key={i}
                              value={elem.leagueId}
                              sx={{ fontSize: "1rem" }}
                            >
                              {elem.eventName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={1}>
                    <FormControl
                      size="small"
                      fullWidth
                      error={filterError.secondaryYear}
                    >
                      <InputLabel>Year</InputLabel>
                      <Select
                        size="small"
                        label="Year"
                        value={secondaryYear}
                        onChange={(e) => setSecondaryYear(e.target.value)}
                        id="idSecondaryYear"
                        sx={{
                          "& #idSecondaryYear": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        {combineYearOptions?.map((elem, i) => {
                          return (
                            <MenuItem key={i} value={elem}>
                              <span title={elem}>{elem}</span>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>Position</InputLabel>
                      <Select
                        value={secondaryPositions}
                        label="Position"
                        onChange={(e) => setSecondaryPositions(e.target.value)}
                        id="idSecondaryPosition"
                        sx={{
                          "& #idSecondaryPosition": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        <MenuItem value="">
                          <span title="None">None</span>
                        </MenuItem>

                        {secondaryPositionOptions?.map((name, i) => {
                          return (
                            <MenuItem key={i} value={name}>
                              {name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={2}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>College or School</InputLabel>
                      <Select
                        size="small"
                        label="College or School"
                        value={secondaryCollege}
                        onChange={(e) => setSecondaryCollege(e.target.value)}
                        id="idSecondaryCollege"
                        sx={{
                          "& #idSecondaryCollege": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        <MenuItem value="">
                          <span title="None">None</span>
                        </MenuItem>
                        {secondaryCollegeOptions?.map((elem, i) => {
                          return (
                            <MenuItem key={i} value={elem}>
                              <span title={elem}>{elem}</span>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl size="small" fullWidth>
                      <InputLabel id="demo-multiple-chip-label-splayer">
                        Players
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label-splayer"
                        multiple
                        value={secondaryPlayers}
                        onChange={handleSecondaryPlayerChange}
                        input={
                          <OutlinedInput
                            id="select-multiple-chip-splayer"
                            label="Chip"
                          />
                        }
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected?.map((value, index) => {
                              var sSecondaryPlayer =
                                secondaryPlayerOptions?.map((val, k) => {
                                  if (val.playerID === value) {
                                    return val.playerName;
                                  }
                                });
                              return (
                                <Chip
                                  key={index}
                                  label={sSecondaryPlayer}
                                  clickable
                                  onDelete={(e) => {
                                    handleDeleteSecondaryPlayer(e, value);
                                  }}
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) =>
                                        event.stopPropagation()
                                      }
                                    />
                                  }
                                />
                              );
                            })}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                        id="idSecondaryPlayers"
                        sx={{
                          "& #idSecondaryPlayers": {
                            fontSize: "0.8rem",
                          },
                        }}
                      >
                        {secondaryPlayerOptions?.map((name, index) => (
                          <MenuItem key={name.playerID} value={name.playerID}>
                            {name.playerName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        </Paper>

        {/* Percentile Accordion */}
        <Box mb={2}>
          <Grid container pt={2} pb={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container>
                <Grid item lg xs={12}>
                  <Paper
                    elevation={8}
                    sx={{
                      borderRadius: "16px",
                    }}
                  >
                    <Box
                      component="div"
                      display="flex"
                      flexGrow={1}
                      flexDirection="column"
                      className={classes.paperStyle}
                    >
                      <AppBar
                        position="static"
                        className={classes.appbar}
                        sx={{
                          borderTopLeftRadius: "15px !important",
                          borderTopRightRadius: "15px !important",
                        }}
                      >
                        <Hidden mdUp>
                          <Tabs
                            scrollButtons
                            allowScrollButtonsMobile
                            value={selectedTab}
                            onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="inherit"
                            variant="scrollable"
                            aria-label="full width tabs example"
                          >
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Anthropometry"
                              {...a11yProps(0)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Strength And Agility"
                              {...a11yProps(1)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Shooting Drills"
                              {...a11yProps(2)}
                            />
                          </Tabs>
                        </Hidden>
                        <Hidden mdDown>
                          <Tabs
                            scrollButtons
                            allowScrollButtonsMobile
                            value={selectedTab}
                            onChange={handleChangeTab}
                            indicatorColor="primary"
                            textColor="inherit"
                            variant="standard"
                            aria-label="full width tabs example"
                          >
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Anthropometry"
                              {...a11yProps(0)}
                            ></Tab>
                            <Tab
                              sx={{ textTransform: "none" }}
                              label=" Strength And Agility"
                              {...a11yProps(1)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Shooting Drills"
                              {...a11yProps(2)}
                            />
                          </Tabs>
                        </Hidden>
                      </AppBar>
                      <SwipeableViews
                        className={classes.swipeView}
                        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                        index={selectedTab}
                        onChangeIndex={handleChangeIndex}
                      >
                        {/* Tab 1 */}
                        <TabPanel
                          value={selectedTab}
                          index={0}
                          dir={theme.direction}
                        >
                          <HistoricalPercentileAnthros
                            anthros={stats.anthros}
                            eventId={eventId}
                            anthroRadarData={anthroRadarData}
                            loading={loading}
                            validateNumber={validateNumber}
                            primaryPlayers={primaryPlayers}
                            anthrosAVGRadarData={anthroAVGRadarData}
                            anthroGroupPercentile={anthroGroupPercentile}
                            isShowGroupPercentile={isShowGroupPercentile}
                            isShowDEXABodyFat={isShowDEXABodyFat}
                          />
                        </TabPanel>

                        <TabPanel
                          value={selectedTab}
                          index={1}
                          dir={theme.direction}
                        >
                          <HistoricalPercentileStrengthAndAgility
                            strengthAndAgility={stats.strengthAndAgility}
                            eventId={eventId}
                            strengthAndAgilityRadarData={
                              strengthAndAgilityRadarData
                            }
                            loading={loading}
                            validateNumber={validateNumber}
                            primaryPlayers={primaryPlayers}
                            strengthAndAgilityAVGRadarData={
                              strengthAndAgilityAVGRadarData
                            }
                            strengthAndAgilityGroupPercentile={
                              strengthAndAgilityGroupPercentile
                            }
                            isShowGroupPercentile={isShowGroupPercentile}
                          />
                        </TabPanel>
                        <TabPanel
                          value={selectedTab}
                          index={2}
                          dir={theme.direction}
                        >
                          <HistoricalPercentileShootingDrills
                            shootingDrills={stats.shootingDrills}
                            eventId={eventId}
                            shootingDrilsRadarData={shootingDrilsRadarData}
                            loading={loading}
                            validateNumber={validateNumber}
                            primaryPlayers={primaryPlayers}
                            shootingDrilsAVGRadarData={
                              shootingDrilsAVGRadarData
                            }
                            shootingDrilsGroupPercentile={
                              shootingDrilsGroupPercentile
                            }
                            isShowGroupPercentile={isShowGroupPercentile}
                          />
                        </TabPanel>
                      </SwipeableViews>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default HistoricalCombineResult;
